import { BaseComponent } from 'components/BaseComponent';
import PropTypes from 'prop-types';
import React from 'react';
import { connect } from 'react-redux';
import { withRouter } from 'react-router-dom';
import { compose } from 'redux';
import { createStructuredSelector } from 'reselect';
import styled from 'styled-components';
import { HBox } from '../../../components/Box';
import { Card } from '../../../components/Card';
import { Cell, List, Row } from '../../../components/List';
import { IsOpen } from '../../../components/Icon';
import { formatCurrencyValue } from '../../../utils/string';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }

  .list-title {
    padding: 8px 0;
  }
`;

const STATE = {
  isOpen: false,
};
/* eslint-disable react/prefer-stateless-function */
class VehicleFinancialDataCardComp extends BaseComponent {
  constructor(props) {
    super(props, {
      ...STATE,
    });
  }

  componentDidMount() {}

  parseOwner(owner) {
    const parsedOwner = {};

    owner.map(prop => {
      parsedOwner[prop.propertyName] = prop.propertyValue;
    });

    return parsedOwner;
  }

  render() {
    const vehicle = this.props.vehicle;
    return (
      <Card className="vehicle-info-card info-card data">
        <Container>
          <HBox>
            <h2 className="list-title">{this.lbl('vehicle.info.data.financial_data')}</h2>

            <div onClick={() => this.setState({ isOpen: !this.state.isOpen })}>
              {' '}
              <IsOpen />
            </div>
          </HBox>
          {this.state.isOpen && (
            <>
              <List>
                {['valuation_price', 'economic_prize'].map(property => {
                  return (
                    <Row key={property}>
                      <Cell>{this.lbl(`vehicle.property.${property}`)}</Cell>
                      <Cell>{vehicle[property] ? formatCurrencyValue(vehicle[property]) : formatCurrencyValue(0)}</Cell>
                    </Row>
                  );
                })}
              </List>
            </>
          )}
        </Container>
      </Card>
    );
  }
}

VehicleFinancialDataCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleFinancialDataCard = compose(withConnect, withRouter)(VehicleFinancialDataCardComp);
